import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/Authentication'

export const AdminFilter = ({ children }) => {
    const auth = useAuth();

    if (auth.user) {
        if (!auth.user.roles.includes('admin')) {
            return <Navigate to={'/'} />
        }
    }

    return children
}